<style scoped lang="less">
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.clickedColor {
  background-color: cornflowerblue;
  border-radius: 5px;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        คิวรถทั้งหมด
      </div>
      <v-spacer></v-spacer>

      <v-btn color="primary" elevation="0" dark link @click="update_qeue">
        <v-icon left>mdi-file-plus</v-icon>บันทึกคิวรถของ {{ this.carUpdate }}
      </v-btn>
    </v-layout>
    <v-divider class="my-4"></v-divider>

    <v-card>
      <div class="d-flex justify-space-around">
        <v-tabs>
          <v-tab
            ><v-btn
              class="ma-2 red lighten-1"
              :loading="loadingSun"
              :disabled="loadingSun"
              @click="(loader = 'loadingSun'), list_qeue('/list-qeue-sun')"
            >
              อาทิตย์
            </v-btn></v-tab
          >
          <v-tab
            ><v-btn
              class="ma-2 yellow lighten-2"
              :loading="loadingMon"
              :disabled="loadingMon"
              @click="(loader = 'loadingMon'), list_qeue('/list-qeue-mon')"
            >
              จันทร์
            </v-btn></v-tab
          >
          <v-tab>
            <v-btn
              class="ma-2 pink accent-1"
              :loading="loadingTue"
              :disabled="loadingTue"
              @click="(loader = 'loadingTue'), list_qeue('/list-qeue-tue')"
            >
              อังคาร
            </v-btn></v-tab
          >
          <v-tab
            ><v-btn
              class="ma-2 light-green accent-2"
              :loading="loadingWed"
              :disabled="loadingWed"
              @click="(loader = 'loadingWed'), list_qeue('/list-qeue-wed')"
            >
              พุธ
            </v-btn></v-tab
          >
          <v-tab
            ><v-btn
              class="ma-2 orange accent-1"
              :loading="loadingThu"
              :disabled="loadingThu"
              @click="(loader = 'loadingThu'), list_qeue('/list-qeue-thu')"
            >
              พฤหัสบดี
            </v-btn></v-tab
          >
          <v-tab
            ><v-btn
              class="ma-2 light-blue accent-1"
              :loading="loadingFri"
              :disabled="loadingFri"
              color=""
              @click="(loader = 'loadingFri'), list_qeue('/list-qeue-fri')"
            >
              ศุกร์
            </v-btn></v-tab
          >
          <v-tab
            ><v-btn
              class="ma-2 deep-purple accent-1"
              :loading="loadingSat"
              :disabled="loadingSat"
              color=""
              @click="(loader = 'loadingSat'), list_qeue('/list-qeue-sat')"
            >
              เสาร์
            </v-btn></v-tab
          >
          <v-tab>
            <v-btn
              class="ma-2 cyan accent-1"
              :loading="loadingAll"
              :disabled="loadingAll"
              @click="(loader = 'loadingAll'), list_qeue('/list-qeue-m1')"
            >
              รายเดือน/1
            </v-btn></v-tab
          >
          <v-tab
            ><v-btn
              class="ma-2 blue lighten-3"
              :loading="loadingAll2"
              :disabled="loadingAll2"
              @click="(loader = 'loadingAll2'), list_qeue('/list-qeue-m2')"
            >
              รายเดือน/2
            </v-btn></v-tab
          >
        </v-tabs>
      </div>

      <v-tabs>
        <v-tab
          v-for="item in car_list"
          :key="item.tab"
          v-model="tab"
          @change="se_tab(item)"
        >
          <v-icon left> mdi-truck-outline </v-icon>
          {{ item.tab }}
        </v-tab>

        <v-tab-item v-for="item in car_list" :key="item.tab">
          <v-card flat
            ><div class="d-flex justify-space-around">
              <v-select
                :items="car_coll"
                item-text="CAR_NUMBER"
                item-value="CAR_NUMBER"
                return-object
                label="รถเก็บขน"
                solo
                @change="(ev) => set_car_coll(ev, (a = 0))"
              ></v-select>
              <v-select
                :items="car_coll"
                item-text="CAR_NUMBER"
                item-value="CAR_NUMBER"
                return-object
                label="รถเก็บขน"
                solo
                @change="(ev) => set_car_coll(ev, (a = 1))"
              ></v-select>
              <v-select
                :items="car_coll"
                item-text="CAR_NUMBER"
                item-value="CAR_NUMBER"
                return-object
                label="รถเก็บขน"
                solo
                @change="(ev) => set_car_coll(ev, (a = 2))"
              ></v-select>

              <v-btn class="mt-2" elevation="0" dark link @click="print_qeue">
                <v-icon left>mdi-file-plus</v-icon>พิมพ์คิวรถประจำวัน
                {{ item.tab }}
              </v-btn>
            </div>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="dessertsReload"
                item-key="id"
                :show-select="false"
                :disable-pagination="true"
                :hide-default-footer="true"
                class="page__table"
              >
                <template v-slot:body="props">
                  <draggable
                    :list="props.items"
                    tag="tbody"
                    :move="onMove(props.items)"
                  >
                    <tr v-for="(item, index) in props.items" :key="index">
                      <td>
                        <v-icon small class="page__grab-icon">
                          mdi-arrow-all
                        </v-icon>
                      </td>
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.CUS_NAME }}</td>
                      <td>{{ item.BILL_ID }}</td>
                      <td>{{ item.CUS_ADDRESS }}</td>
                      <td>{{ item.CUS_PHONE }}</td>
                    </tr>
                  </draggable>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import printCar_Qeue from "./pdf/printCar_Qeue";
export default {
  components: {
    draggable,
  },
  name: "CarQeue",
  data: () => ({
    upData: "",
    loader: null,
    loadingSun: false,
    loadingMon: false,
    loadingTue: false,
    loadingWed: false,
    loadingThu: false,
    loadingFri: false,
    loadingSat: false,
    loadingAll: false,
    loadingAll2: false,
    tab: null,
    carUpdate: "",
    car_list: [],
    reoadApi: "",
    headers: [
      {
        text: "",
        align: "start",
        sortable: false,
        width: "90",
      },
      {
        text: "ลำดับ",
        sortable: false,
        value: "name",
        width: "90",
      },
      { text: "รายชื่อ", value: "", sortable: false },
      { text: "รหัสวางบิล", value: "", sortable: false, width: "100" },
      { text: "ที่อยู่", value: "", sortable: false },
      { text: "เบอร์โทร", value: "", sortable: false, width: "300" },
    ],
    desserts: [],
    Onclicked: "",
    keyCar_print: "",
    car_coll: [],
    get_arr_car_coll: ["", "", ""],
  }),
  watch: {
    loader() {
      const l = this.loader;
      //console.log(l);

      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 2000);

      this.loader = null;
    },
  },
  filters: {},
  computed: {
    dessertsReload() {
      return this.desserts;
    },
  },
  methods: {
    se_tab(e) {
      //console.log(e);
      //console.log(this.upData );
      //this.update_qeue()
      this.carUpdate = e.tab;
      this.list_data_byCarnumber(e);
    },
    onMove(item) {
      console.log(item);
      this.upData = item;
      //api update
    },
    list_qeue(api) {
      // console.log(api);
      this.Onclicked = api;
      this.reoadApi = api;

      this.$token_api
        .get(api)
        .then((response) => {
          let dataAll = response.data.data;
          //console.log('***********');
          //console.log(dataAll);
          let listQeue = [];
          for (const key in dataAll) {
            if (dataAll.hasOwnProperty(key)) {
              listQeue.push({ tab: dataAll[key].CAR_NUM });
            }
          }
          //Remove Duplicates tab In Array
          const filteredArr = listQeue.reduce((acc, current) => {
            const x = acc.find((item) => item.tab === current.tab);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
          //console.log(filteredArr);
          this.car_list = filteredArr;
          // console.log(this.car_list);
          this.list_data_byCarnumber(this.car_list[0]);
          this.carUpdate = this.car_list[0].tab;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async update_qeue() {
      console.log(this.upData);
      await this.$token_api
        .post("/qeue-update", this.upData)
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.$swal({
              title: "สำเร็จ",
              text: "บันทึเรียบร้อบ",
              timer: 2000,
              icon: "success",
            });
            this.list_qeue(this.reoadApi);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //flutter config --android-studio-dir="D:\Android"
    list_data_byCarnumber(e) {
      //select by CAR_NUMBER
      // console.log(this.Onclicked);
      this.$token_api
        .post("/post-data-by-car-number-web", {
          tab: e.tab,
          day_collect: this.Onclicked,
        })
        .then((res) => {
          let detailAll = res.data.data;
          let detailQeue = [];
          for (const key in detailAll) {
            if (detailAll.hasOwnProperty(key)) {
              detailQeue.push(detailAll[key]);
            }
          }

          this.desserts = detailQeue;

          // console.log(this.desserts);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reloadQeue() {
      var d = new Date();
      var n = d.getDay();
      var loopday = [
        "/list-qeue-sun",
        "/list-qeue-mon",
        "/list-qeue-tue",
        "/list-qeue-wed",
        "/list-qeue-thu",
        "/list-qeue-fri",
        "/list-qeue-sat",
      ];
      this.list_qeue(loopday[n]);
      // var a = "/list-qeue-all";
      // this.Onclicked = a;
      //this.list_qeue(a);
    },
    print_qeue() {
      this.printCar_Qeues(this.desserts, this.get_arr_car_coll);
    },
    async printCar_Qeues(item, car_coll) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await printCar_Qeue(item, car_coll)).open();
    },
    fn_car_coll() {
      this.$token_api
        .get("/get-car-collect")
        .then((response) => {
          this.car_coll = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    set_car_coll(car, arr) {
      this.get_arr_car_coll[arr] = car;
      // console.log(this.get_arr_car_coll);
    },
  },
  mounted() {},
  created() {
    this.reloadQeue();
    this.fn_car_coll();
  },
};
</script>
<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
